import { ElemDatasetMixinTypes } from './types';
import { ELEM_DATASET_MIXIN_NAME } from './const';
import { isEqual } from 'lodash';

export const ElemDatasetMixin = {
    _name: ELEM_DATASET_MIXIN_NAME,
    data() {
        return {
            /**
             * @type {import('@goodt-common/data').IDatasetResult|null}
             */
            result: null,
            isLoading: false,
            // typings
            ...ElemDatasetMixinTypes
        };
    },
    computed: {
        /**
         *
         * @return {number}
         */
        limit() {
            return this.request?.limit;
        },
        offset: {
            get() {
                return this.request?.offset;
            },
            set(offset) {
                if (this.request != null) {
                    this.request.offset = offset;
                }
            }
        },
        /**
         * @return {number}
         */
        page: {
            /**
             * @param {number} page
             */
            set(page) {
                this.offset = (page - 1) * this.limit;
            },
            /**
             * @return {number}
             */
            get() {
                return this.limit ? this.offset / this.limit + 1 : 1;
            }
        },
        /**
         * @return {number}
         */
        pages() {
            // @ts-ignore
            return this.limit ? Math.ceil(this.rowCount / this.limit) : 1;
        },
        /**
         * @return {number}
         */
        rowCount() {
            return this.result?.rowCount ?? 0;
        },
        /**
         * @return {import('../request').Request|null}
         */
        request() {
            return this.requests[0] ?? null;
        }
    },

    watchEditor: {
        request: {
            handler(request, oldRequest) {
                if (isEqual(oldRequest, request) === false) {
                    this.result = null;
                }
            },
        }
    },

    methods: {
        /**
         * @param {(import('@goodt-common/data').Request|null)[]|Request|null} [requestToLoad=this.request]
         * @return {Promise<void>}
         */
        async loadData(requestToLoad = this.request) {
            const [request] = [requestToLoad].flat();
            const { loadDataHooks} = this;

            // reuse ElemDatasetBaseMixin.$requestFetch
            await this.$requestFetch([request], {
                then: (results) => {
                    this.result = results[0] ?? null;
                    loadDataHooks.then?.(this.result);
                },
                catch: (error) => {
                    this.result = null;
                    loadDataHooks.catch?.(error);
                }
            });

            /*
            this.$requestCancel(request);

            if (this.loadDataHooks.before != null) {
                const cancelToken = new CancelToken();
                this.loadDataHooks.before.call(this, cancelToken.cancel.bind(cancelToken));
                if (cancelToken.isCancelled === true) {
                    return;
                }
            }

            try {
                this.result = await request.send();
                this.loadDataHooks.then?.call(this, this.result);
            } catch (error) {
                this.result = null;
                this.$handleError(error, {
                    scope: {
                        method: 'loadData'
                    }
                });
                this.loadDataHooks.catch?.call(this, error);
            } finally {
                this.loadDataHooks.finally?.call(this);
            }
            */
        }
    }
};
